import React from 'react';
import { Link } from 'react-router-dom';
import { Tab, Nav } from 'react-bootstrap';
import { IMAGES } from '../constants/theme';

const FitnessGoal = ({ isOpenModal }) => {
  return (
    <>
      <div className="col-lg-6 about-content m-b30">
        <div className="section-head m-0">
          <span className="sub-title">ABOUT HYBRID PERFORMANCE ACADEMY</span>
          <h2 className="title">
            Train <span>Smarter</span>, Perform Better
          </h2>
          <p className="m-0">
            Hybrid Performance Academy is a digital training platform designed to
            remove confusion from strength and performance training through
            structured, science-based online education.
          </p>
        </div>

        <div className="" data-wow-delay="0.8s">
          <Tab.Container defaultActiveKey={'Mission'}>
            <Nav as="ul" className="nav nav-tabs style-1 m-b20 m-t30">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey={'Mission'}>
                  <span>Our Mission</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey={'Vision'}>
                  <span>Our Vision</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content className="tab-content m-sm-b30 m-b40 p-r30" id="myTabContent">
              <Tab.Pane eventKey={'Mission'}>
                <div className="content">
                  <p>
                    Our mission is to provide athletes, coaches, and fitness
                    enthusiasts with clear, practical, and progressive online
                    training content. We focus on strength, conditioning, and
                    performance principles that actually work — without trends,
                    hype, or guesswork.
                  </p>
                </div>
              </Tab.Pane>

              <Tab.Pane eventKey={'Vision'}>
                <div className="content">
                  <p>
                    Our vision is to become a trusted global platform for hybrid
                    performance education, where users can access high-quality
                    video libraries, structured programs, and intelligent
                    recommendations tailored to their goals and subscriptions.
                  </p>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <div className="contact-us">
          <span className="icon">
            <i className="fa-solid fa-headset"></i>
          </span>
          <div className="content">
            <span>Need guidance?</span>
            <h4 className="number">Online Support Available</h4>
          </div>
        </div>
      </div>

      <div className="col-lg-6 m-b30">
        <div className="dz-media">
          <div className="image-box">
            <div className="video-bx1 h-auto w-auto overflow-visible">
              <img src={IMAGES.boxpic1} alt="" />
              <div className="video-btn sm">
                <Link
                  to={"#"}
                  className="popup-youtube"
                  onClick={() => isOpenModal(true)}
                >
                  <i className="fa fa-play" />
                </Link>
              </div>
            </div>
            <div className="info-box">
              <span>
                <i className="flaticon-play text-primary"></i> On-Demand Training Videos
              </span>
            </div>
          </div>

          <div className="image-box">
            <img src={IMAGES.boxpic2} alt="" />
            <div className="info-box">
              <span>
                <i className="flaticon-athletics text-primary"></i> Performance-Driven Education
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FitnessGoal;
